'use strict';

/**
 * @param {Object} object
 * @param {string|string[]} path
 * @param {*} [defaultValue]
 * @returns {*}
 */
export default function get(object, path, defaultValue) {
    if (object == null) {
        return defaultValue;
    }
    const keys = Array.isArray(path) ? path : String(path).split('.');
    let result = object;
    for (let i = 0; i < keys.length; i++) {
        if (result == null || !Object.hasOwn(result, keys[i])) {
            return defaultValue;
        }
        result = result[keys[i]];
    }
    return result === undefined ? defaultValue : result;
}
